import { combineReducers } from "redux";
import { popularReducer } from "./popular/reducers";
import { upcomingReducer } from "./upcoming/reducers";
import { playingReducer } from "./playing/reducers";
import { detailsReducer } from "./details/reducers";
import { favoritesReducer } from "./favorites/reducers";
import { similliarReducer } from "./similiar/reducers";
import { searchReducer } from "./search/reducers";

export default combineReducers({
  details: detailsReducer,
  popular: popularReducer,
  favorites: favoritesReducer,
  search: searchReducer,
  similliar: similliarReducer,
  upcoming: upcomingReducer,
  playing: playingReducer
});
